import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import Modal from 'app/components/common/modal';
import StandardSelect from 'app/components/common/standard-select';
import GrantSysDuck from 'app/ducks/company-admin/grant-system';
import helpers from 'app/helpers/grant-system';
import Ps from 'app/helpers/publish-statuses';
import ToastAx from 'app/actions/toast';

class CadminModalReassignGrantApp extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      programId: null,
    };

    this.onChangeProgram = this.onChangeProgram.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
  }

  componentDidMount() {
    this.props.loadPrograms();
  }

  onChangeProgram(programId) {
    this.setState({programId});
  }

  onClickSubmit() {
    this.props.reassign(this.state.programId).then(() => {
      this.props.toastSuccess('Application has been reassigned.');
      this.onClose();
    });
  }

  onClose() {
    this.props.onClose();
  }

  renderProgramInput() {
    if (!this.props.programs) return 'loading...';
    const programs = this.props.programs.filter((program) => {
      if (program.id === this.props.app.grantProgramId) return false;
      if (program.publishStatus !== Ps.ACTIVE) return false;
      return true;
    });
    const options = programs.map(p => ({value: p.id, label: p.title}));
    return <StandardSelect options={options} onSelect={this.onChangeProgram} value={this.state.programId} allowClear />;
  }

  render() {
    const {app, isPending} = this.props;
    const btnDisabled = (() => {
      if (!this.state.programId) return true;
      if (isPending) return true;
      return false;
    })();
    const btnLabel = isPending ? 'Reassigning...' : 'Reassign Application';

    return (
      <Modal className="bform" onClose={this.onClose}>
        <h1 className="bform-h1">Reassign Application</h1>

        <label className="bform-h3">Choose a new program</label>
        {this.renderProgramInput()}

        <div className="bform-actions">
          <div className="bform-actions-right">
            <button className="btn blue" onClick={this.onClickSubmit} disabled={btnDisabled}>{btnLabel}</button>
          </div>
        </div>
      </Modal>
    );
  }

}

CadminModalReassignGrantApp.defaultProps = {
  app: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

const stateToProps = (state) => ({
  programs: GrantSysDuck.Slx.allPrograms(state),
  isPending: GrantSysDuck.Slx.appReassignPending(state),
});

const dispatchToProps = (dispatch, ownProps) => ({
  loadPrograms: () => dispatch(GrantSysDuck.Ax.programsSearch()),
  reassign: (programId) => dispatch(GrantSysDuck.Ax.appsReassign(ownProps.app.id, programId)),
  toastSuccess: (msg) => dispatch(ToastAx.success(msg)),
});

export default connect(stateToProps, dispatchToProps)(CadminModalReassignGrantApp);
